import ImmutablePropTypes from 'react-immutable-proptypes';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { libraryShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { SecondarySolidLink } from '@bibliocommons/base-links';
import { LiteSuggestionButtonContainer } from './LiteSuggestionButton';
import { PremiumSuggestionButtonContainer } from './PremiumSuggestionButton';
import { SuggestForPurchaseInfo } from './SuggestForPurchaseInfo';

import './SuggestForPurchaseButton.scss';

export default function SuggestForPurchaseButton({ currentLibrary, liteSuggestions, premiumSuggestions, user }) {
  const externalLink = currentLibrary.getIn(['suggestForPurchase', 'externalLink']);
  const liteEnabled = currentLibrary.getIn(['suggestForPurchase', 'lite', 'enabled']);
  const premiumEnabled = currentLibrary.getIn(['suggestForPurchase', 'premium', 'enabled']);
  const premiumStaffOnly = currentLibrary.getIn(['suggestForPurchase', 'premium', 'staffOnly']);
  const userRole = user ? user.getIn(['roles']) : null;
  const userPermission = user ? user.getIn(['permissions']) : null;
  const isStaff =
    userRole &&
    (userRole.includes('SYS_ADMIN') ||
      userRole.includes('LIBRARY_STAFF') ||
      userRole.includes('LIBRARY_ADMIN') ||
      userPermission.includes('SUGGESTED_PURCHASES'));

  function renderContent() {
    if (externalLink) {
      return (
        <SecondarySolidLink href={externalLink} dataKey="external-suggestion-link" block>
          <FormattedMessage id="suggest_for_purchase" />
        </SecondarySolidLink>
      );
    }

    if (liteSuggestions?.size || premiumSuggestions?.size) {
      return <SuggestForPurchaseInfo message={<FormattedMessage id="already_suggested_title" />} />;
    }

    if (liteEnabled) {
      return <LiteSuggestionButtonContainer />;
    }

    if (premiumEnabled) {
      if (user && (!premiumStaffOnly || isStaff)) {
        return <PremiumSuggestionButtonContainer />;
      }
      return null;
    }

    return null;
  }

  const content = renderContent();
  return content ? <div className="cp-suggest-for-purchase-button">{content}</div> : null;
}

SuggestForPurchaseButton.propTypes = {
  currentLibrary: libraryShape.isRequired,
  liteSuggestions: ImmutablePropTypes.list.isRequired,
  premiumSuggestions: ImmutablePropTypes.list.isRequired,
  user: userIdentityShape
};
